var render, staticRenderFns
import script from "./WdmParameterSelect.vue?vue&type=script&lang=js&"
export * from "./WdmParameterSelect.vue?vue&type=script&lang=js&"
import style0 from "./WdmParameterSelect.vue?vue&type=style&index=0&id=25160497&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports